import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AppFilter } from '@app/shared/models';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  apiUrl: string = environment.API_SERVER;
  organizationId: string = localStorage.getItem('organizationId');
  constructor(private http: HttpClient) {}

  getAlerts(payload: AppFilter) {
    return this.http.get(`${this.apiUrl}/api/v1/alert/`, {
      params: payload as any,
    });
  }

  getAlertScenarios(payload: AppFilter) {
    return this.http.get(`${this.apiUrl}/api/v1/alert/scenarios`, {
      params: payload as any,
    });
  }

  getUsersOnEservices(payload: AppFilter) {
    return this.http.get(`${this.apiUrl}/api/v1/meta-users/all`, {
      params: payload as any,
    });
  }

  getNormalUsersOnEservices(payload: AppFilter) {
    return this.http.get(
      `${this.apiUrl}/organizations/${this.organizationId}/users`,
      {
        params: payload as any,
      }
    );
  }

  getNotificationPreferences(payload: AppFilter) {
    return this.http.get(
      `${this.apiUrl}/api/v1/settings/by-type?settingsType=notification_settings`,
      {
        params: payload as any,
      }
    );
  }

  createAlert(body: any) {
    return this.http.post(`${this.apiUrl}/api/v1/alert/`, body);
  }

  getAlertNotifications(payload: AppFilter) {
    return this.http.get(`${this.apiUrl}/api/v1/alert/logs/`, {
      params: payload as any,
    });
  }

  deleteAlert(alertId: string) {
    return this.http.delete(`${this.apiUrl}/api/v1/alert/${alertId}`);
  }

  editAlert(alertId: string, body: any) {
    return this.http.put(
      `${this.apiUrl}/api/v1/alert/${alertId}?status=${body.status}`,
      body
    );
  }

  editAlertStatus(alertId: string, body: any) {
    return this.http.put(
      `${this.apiUrl}/api/v1/alert/status-update/${alertId}/?status=${body.status}`,
      body
    );
  }
}
